<template>
  <VeeForm v-slot="{ meta, handleSubmit }" as="">
    <form
      autocomplete="off"
      class="bg-neutral-secondary p-4 rounded-md"
      @submit="handleSubmit($event, onSubmit)"
    >
      <VeeField v-slot="{ field }" v-model="formModel.fromDate" name="fromDate">
        <div>
          <NText
            class="mt-2 ms-3 whitespace-nowrap text-neutral-secondary-press"
            variant="caption1"
            weight="medium"
          >
            {{ t('common.fromDate') }}
          </NText>
          <Datepicker
            v-bind="field"
            v-model="formModel.fromDate"
            class="mt-1 mb-0"
          />
        </div>
      </VeeField>

      <VeeField v-slot="{ field }" v-model="formModel.endDate" name="endDate">
        <div>
          <NText
            class="mt-1 ms-3 whitespace-nowrap text-neutral-secondary-press"
            variant="caption1"
            weight="medium"
          >
            {{ t('common.toDate') }}
          </NText>
          <Datepicker
            v-bind="field"
            v-model="formModel.endDate"
            class="mt-2 mb-0"
          />
        </div>
      </VeeField>

      <div class="mt-8">
        <NButton
          :disabled="!meta.dirty"
          variant="fill"
          type="submit"
          color="green"
          class="w-full"
        >
          {{ t('common.applyFilters') }}
        </NButton>
      </div>
    </form>
  </VeeForm>
</template>

<script setup lang="ts">
import { reactive } from 'vue';
import { useI18n } from 'vue-i18n';
import { useRoute, useRouter } from 'vue-router';
import { toShortDate } from '@libs/utils';
import { useDialog } from '@negar/core';

import Datepicker from '@/components/Datepicker/index.vue';
import { toGregorian } from '@/components/Datepicker/convertor';
import { DEFAULT_DATE } from '@/components/Datepicker/constants';

const { t } = useI18n();
const route = useRoute();
const router = useRouter();
const { remove: removeDialog } = useDialog();

const { fromDate, endDate } = route.query;

const formModel = reactive({
  fromDate: fromDate
    ? new Date(fromDate as string)
    : new Date(
        ...toGregorian({
          year: DEFAULT_DATE.year,
          month: DEFAULT_DATE.month,
          day: DEFAULT_DATE.day,
        })
      ),
  endDate: endDate ? new Date(endDate as string) : new Date(),
});

const onSubmit = () => {
  router.push({
    path: '/account-turnover',
    query: {
      fromDate: toShortDate(formModel.fromDate),
      endDate: toShortDate(formModel.endDate),
    },
  });

  removeDialog();
};
</script>
